const SCOPE = 'app/promocode/';
export const ActionTypes = {
    CHANGE_VALUE: `${SCOPE}CHANGE_VALUE`,
    CHANGE_NAME: `${SCOPE}CHANGE_NAME`,
    CHANGE_IS_LOADING: `${SCOPE}CHANGE_IS_LOADING`,
    CHANGE_MODAL_IS_VISIBLE: `${SCOPE}CHANGE_MODAL_IS_VISIBLE`,
    ON_VALUE_HAS_BEEN_SET: `${SCOPE}ON_VALUE_HAS_BEEN_SET`,
    ON_VALUE_HAS_BEEN_RESET: `${SCOPE}ON_VALUE_HAS_BEEN_RESET`,
};

export const changeValue = (value) => ({ type: ActionTypes.CHANGE_VALUE, value });
export const changeName = (name) => ({ type: ActionTypes.CHANGE_NAME, name });
export const changeIsLoading = (isLoading) => ({
    type: ActionTypes.CHANGE_IS_LOADING,
    isLoading,
});
export const changeModalIsVisible = (isVisible) => ({
    type: ActionTypes.CHANGE_MODAL_IS_VISIBLE,
    isVisible,
});
export const onValueHasBeenSet = () => ({
    type: ActionTypes.ON_VALUE_HAS_BEEN_SET,
});
export const onValueHasBeenReset = () => ({
    type: ActionTypes.ON_VALUE_HAS_BEEN_RESET,
});
